import { useSelector } from 'react-redux'
import { Panel } from '../../common/panel'
import { selectCompanyInfo } from '../common/header/companyInfo/store/slice'
import { PANEL_ID } from './constant'
import { selectCompanyInfoDetail } from './store/slice'
import {
  exportBoardOfDirector,
  exportBoardOfManagement,
  exportCompanyOverview,
  exportIndustry,
} from './store/thunk'

export const PanelItem = ({ item }) => {
  const { organizationId } = useSelector(selectCompanyInfo)

  const isManagementHasData = useSelector(
    selectCompanyInfoDetail((detailData) => {
      const data = detailData.companyBoardOfManagement
      return data && data.length
    }),
  )
  const isDirectorHasData = useSelector(
    selectCompanyInfoDetail((detailData) => {
      const data = detailData.companyBoardOfDirector
      return data && data.length
    }),
  )
  const isIndustryHasData = useSelector(
    selectCompanyInfoDetail((detailData) => {
      return (
        detailData.icbIndustries?.length || detailData.vsicIndustries?.length
      )
    }),
  )

  const getDownloadCsv = () => {
    const params = { organizationId }
    switch (item.id) {
      case PANEL_ID.OVERVIEW:
        return {
          downloadFunc: () => exportCompanyOverview(params),
          disabled: !organizationId,
        }
      case PANEL_ID.INDUSTRY:
        return {
          downloadFunc: () => exportIndustry(params),
          disabled: !organizationId || !isIndustryHasData,
        }
      case PANEL_ID.DIRECTOR:
        return {
          downloadFunc: () => exportBoardOfDirector(params),
          disabled: !organizationId || !isDirectorHasData,
        }
      case PANEL_ID.MANAGEMENT:
        return {
          downloadFunc: () => exportBoardOfManagement(params),
          disabled: !organizationId || !isManagementHasData,
        }
      default:
        break
    }
  }

  const ItemComponent = item.component

  return (
    <Panel
      id={item.id}
      label={item.label}
      type={item.type}
      isI18n
      style={{ height: 'unset' }}
      downloadCsv={getDownloadCsv()}
    >
      <ItemComponent />
    </Panel>
  )
}
